export enum ErrorTypes {
  ACCESS_TOKEN_INVALID = "accesstokeninvalid",
  AUTH_STATE_INVALID = "authstateinvalid",
  CANNOT_ACQUIRE_ACCESS_TOKEN = "cannotacquireaccesstoken",
  CANNOT_CREATE_MEETING = "cannotcreatemeeting",
  CANNOT_STAMP_EPIC_EXTENSION = "cannotstampepicextension",
  EHR_QUEUE_NOT_SETUP = "ehrqueuenotsetup",
  EHR_QUEUE_NO_ACCESS = "ehrqueuenoaccess",
  EPIC_AUTH = "epicauth",
  EPIC_ERROR = "epicerror",
  INVALID_SESSION = "invalidsession",
  ISSUER_URL_INVALID = "issuerurlinvalid",
  LICENSE_NOT_FOUND = "licensenotfound",
  M365_AUTH = "m365auth",
  ORGANIZER_ID_NOT_FOUND = "organizeridnotfound",
  PAGE_NOT_FOUND = "pagenotfound",
  SESSION_EXPIRED = "sessionexpired",
  TENANT_CONFIG_NOT_APPROVED = "tenantconfignotapproved",
  TENANT_CONFIG_NOT_FOUND = "tenantconfignotfound",
  TENANT_SUSPENDED = "tenantsuspended",
  UNAUTHORIZED_USER = "unauthorizeduser",
  UNAVAILABLE_IN_GCC = "configportalunavailableingcc",
  UNKNOWN = "unknown",
  UNSUPPORTED_BROWSER = "unsupportedbrowser",
  USER_CONFIG_ALREADY_EXISTS = "userconfigalreadyexists",
  USER_TYPE_INVALID = "usertypeinvalid",
}
